<script setup lang="ts">
import draggable from "vuedraggable"
import { formElements } from "./formElements"
import type { EditorNode, FormElement } from "./types"
import type { FormBuilder } from "./useFormBuilder"

const { formBuilder } = defineProps<{ formBuilder: FormBuilder }>()

function cloneItem(item: FormElement): EditorNode {
    return formBuilder.createNode(item.type)
}
</script>

<template>
    <div class="fb-palette">
        <div class="fb-palette__title">{{ $t("components:form_builder.palette_title") }}</div>
        <draggable
            :list="[...formElements.values()]"
            :group="{ name: 'form-fields', pull: 'clone', put: false }"
            :clone="cloneItem"
            :sort="false"
            item-key="type"
        >
            <template #item="{ element }">
                <div class="fb-palette__item">
                    <i :class="`fa fa-fw ${element.icon}`"></i>
                    {{ $t(element.label) }}
                </div>
            </template>
        </draggable>
    </div>
</template>

<style lang="scss" scoped>
.fb-palette {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    user-select: none;

    &__title {
        font-size: 0.7rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        color: #6c757d;
        padding-bottom: 0.5rem;
        border-bottom: 1px solid #dee2e6;
        margin-bottom: 0.25rem;
    }

    &__item {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.4rem 0.6rem;
        margin-bottom: 0.25rem;
        border-radius: 4px;
        cursor: grab;
        font-size: 0.8rem;
        background: #f8f9fa;
        border: 1px solid #dee2e6;
        transition: background 0.1s, border-color 0.1s;

        &:hover {
            background: #e9ecef;
            border-color: #adb5bd;
        }

        &:active {
            cursor: grabbing;
        }
    }
}
</style>
